import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import PublicRoute from 'components/route/public';
import PrivateRoute from 'components/route/private';
import Dashboard from 'pages/dashboard';
import UserLogin from 'pages/user/login';
import UserRegister from 'pages/user/register';
import UserForgotPassword from 'pages/user/forgot_password';
import UserConfirmation from 'pages/user/confirmation';
import UserResetPassword from 'pages/user/reset_password';
import Profile from 'pages/user/profile';
import DeleteConfirmation from 'pages/user/delete_confirmation';
import Inspections from 'pages/inspections';
import InspectionSubjects from 'pages/inspection_subjects';
import Places from 'pages/places';
import PlacesShow from 'pages/places/show';
import InspectionSubject from 'pages/inspection_subjects/show';
import Inspection from 'pages/inspections/show';
import Templates from 'pages/templates';
import Template from 'pages/templates/show';
import Users from 'pages/users';
import UserInvitationConfirmation from 'pages/users/invitation_confirmation';
import GoogleCallback from 'pages/auth/google/callback';
import Terms from 'pages/legal/Terms';
import PaymentTerms from 'pages/legal/PaymentTerms';
import PrivacyPolicy from 'pages/legal/PrivacyPolicy';
import PublicAuthRoute from 'components/route/public_auth';
import CommonRoute from 'components/route/common';
import PrivateNoSpaceRoute from 'components/route/private_no_space';
import Spaces from 'pages/spaces';
import Billing from 'pages/spaces/billing';
import RootLayout from './root_layout';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      <Route element={<PublicAuthRoute />}>
        <Route path="/users/login" element={<UserLogin />} />
        <Route path="/users/register" element={<UserRegister />} />
        <Route path="/users/forgot_password" element={<UserForgotPassword />} />
        <Route path="/users/reset_password/:token" element={<UserResetPassword />} />
        <Route path="/users/confirm/:token" element={<UserConfirmation />} />
        <Route path="*" element={<UserLogin />} />
      </Route>
      <Route element={<CommonRoute />}>
        <Route path="/terms" element={<Terms />} />
        <Route path="/payment-terms" element={<PaymentTerms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Route>
      <Route element={<PrivateNoSpaceRoute />}>
        <Route path="/spaces" element={<Spaces />} />
      </Route>
      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/inspections" element={<Inspections />} />
        <Route path="/inspections/:inspectionId" element={<Inspection />} />
        <Route path="/inspection_subjects" element={<InspectionSubjects />} />
        <Route path="/inspection_subjects/:inspectionSubjectId" element={<InspectionSubject />} />

        <Route path="/places" element={<Places />} />
        <Route path="/places/:id" element={<PlacesShow />} />

        <Route path="/profile" element={<Profile />} />
        <Route path="/users/delete/:token" element={<DeleteConfirmation />} />

        <Route path="/templates" element={<Templates />} />
        <Route path="/templates/:id" element={<Template />} />

        <Route path="/users" element={<Users />} />
        <Route path="/users/invitation/confirm/:token" element={<UserInvitationConfirmation />} />

        <Route path="/auth/google/callback" element={<GoogleCallback />} />

        <Route path="*" element={<Dashboard />} />
      </Route>
    </Route>
  )
);

export default router;
